import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { WORKSPACE_SERVICE_URI } from '@workspace/shared/constants/envConfig';
let WorkspaceApiServiceImpl = class WorkspaceApiServiceImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${WORKSPACE_SERVICE_URI}/workspace/web`,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async findPatentFolders(data) {
        const res = await this.post({
            url: 'patents/exist/detail',
            data,
        });
        return res.data;
    }
    async getComments(data) {
        const res = await this.post({
            url: 'comment/console/list',
            data,
            transformCode: true,
        });
        return res.data;
    }
    async changeCommentScope(data) {
        const res = await this.post({
            url: 'comment/console/visible-scope',
            data,
            transformCode: true,
        });
        return res.data;
    }
    async shortQuery(data) {
        const res = await this.post({
            url: `folder/${data.folder_id}/short-query`,
            data,
        });
        return res.data;
    }
};
WorkspaceApiServiceImpl = __decorate([
    injectable()
], WorkspaceApiServiceImpl);
export { WorkspaceApiServiceImpl };
